import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function ProfileStepsTab(props) {
  const [profileData,setProfileData]=useState(props.profile);
  useEffect(()=>{
    setProfileData({...props.profile});
  },[props.profile])
  const getobject=(data) => {
    let compArray=props?.profile?.profileStepsCompleted||[];
    
    for (var i=0, iLen=compArray.length; i<iLen; i++) {

        if (compArray[i].name == data) 
        {
            return compArray[i].value;
        }
        // return false;
      }
  }
  const { sellerAddress} =
  useSelector((state) => state.profileReducer);
//   console.log("props",props);
  return (
    <div className="steps-tab dis-flex justify-content-between white-bg border-2">
        <div className={`steps dis-flex ${(getobject('step1'))||props.step=="step1"?'active':""}`}>
            <div className="step-icon">
              <img src={`/step-${(getobject('step1'))?'done':"disable"}.webp`} class="menu-icon" alt="icon" />
            </div>
            <div className="step-info">
                <div className="header">Step 1</div>
                <div className="title">Add Personal Information</div>
            </div>
        </div>
        <div className={`steps dis-flex ${(getobject('step2'))||props.step=="step2"?'active':""}`}>
            <div className="step-icon">
             <img src={`/step-${(getobject('step2'))?'done':"disable"}.webp`} class="menu-icon" alt="icon" />
            </div>
            <div className="step-info">
                <div className="header">Step 2</div>
                <div className="title">Add Addresses</div>
            </div>
        </div>
        <div className={`steps dis-flex ${(getobject('step3'))||props.step=="step3"?'active':""}`}>
            <div className="step-icon">
             <img src={`/step-${(getobject('step3'))?'done':"disable"}.webp`} class="menu-icon" alt="icon" />
            </div>
            <div className="step-info">
                <div className="header">Step 3</div>
                <div className="title">Add Bank Details</div>
            </div>
        </div>
        <div className={`steps dis-flex ${profileData?.active?'active':""}`}>
            <div className="step-icon">
             <img src={`/step-${profileData?.active?'done':"disable"}.webp`} class="menu-icon" alt="icon" />
            </div>
            <div className="step-info">
                <div className="header">Step 4</div>
                <div className="title">Add Products</div>
            </div>
        </div>
    </div>
  );
}

export default ProfileStepsTab;
